import { LookupListItem } from '../../api/user/model';
import { GET_ORGANISATIONS_LIST_URL } from '../../constants/apiUrls';
import { GET_ORGANISATION_LIST_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';

interface Input {
  type?: string;
}

export const useGetOrganisationList = ({ type }: Input = {}) => {
  const getOrganisationlist = async () => {
    const res = await axiosClient.get<LookupListItem[]>(GET_ORGANISATIONS_LIST_URL, {
      params: {
        type,
      },
    });

    return res.data;
  };

  return useCustomQuery(
    [GET_ORGANISATION_LIST_QUERY_KEY, type],
    getOrganisationlist,
    {
      staleTime: Infinity,
    },
    false
  );
};
